import React from 'react';
import { MessageCircle, Edit, XCircle } from 'lucide-react';

/**
 * CalendarContextMenu - Right-click context menu for calendar slots
 */
const CalendarContextMenu = ({
  contextMenu,
  isAdmin,
  selectedAvailability,
  onToggleHoldStatus,
  onDeleteAvailability,
  onAppointmentClick,
  onAvailabilityClick,
  onEditAppointment,
  onCancelAppointment,  // Handler for customer cancellation
  onSendMessage,        // NEW: Handler for sending message to customer
  onClose
}) => {
  if (!contextMenu) return null;

  return (
    <div
      className="fixed bg-white shadow-lg rounded-md border border-gray-200 py-2 z-50"
      style={{ top: contextMenu.y, left: contextMenu.x }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* BOOKING CONTEXT MENU - Right-click on a booking card */}
      {contextMenu.isBookingContextMenu && isAdmin ? (
        <>
          <button
            onClick={() => {
              onEditAppointment && onEditAppointment();
              onClose();
            }}
            className="w-full px-6 py-2 text-left hover:bg-yellow-50 transition-colors flex items-center gap-2"
          >
            <Edit className="w-4 h-4" />
            <span className="font-medium">Edit Booking</span>
          </button>
          <button
            onClick={() => {
              onSendMessage && onSendMessage(contextMenu.appointment);
              onClose();
            }}
            className="w-full px-6 py-2 text-left hover:bg-blue-50 transition-colors flex items-center gap-2"
          >
            <MessageCircle className="w-4 h-4" />
            <span className="font-medium">Send Message</span>
          </button>
          <button
            onClick={() => {
              onCancelAppointment && onCancelAppointment();
              onClose();
            }}
            className="w-full px-6 py-2 text-left hover:bg-red-50 transition-colors text-red-600 flex items-center gap-2"
          >
            <XCircle className="w-4 h-4" />
            <span className="font-medium">Cancel Booking</span>
          </button>
        </>
      ) : /* Show message for past slots without availability */
      isAdmin && !contextMenu.hasAvailability && contextMenu.isPastSlot ? (
        <div className="px-6 py-2 text-gray-500 text-sm">
          Past slot - no actions available
        </div>
      ) : contextMenu.isCustomerBooking ? (
        // CUSTOMER CONTEXT MENU (Jan 15, 2026):
        // Show Cancel option for customers viewing their own bookings
        <button
          onClick={() => {
            onClose();
            if (onCancelAppointment) {
              onCancelAppointment();
            }
          }}
          className="w-full px-6 py-2 text-left hover:bg-red-50 transition-colors text-red-600"
        >
          <span className="font-medium">Cancel Appointment</span>
        </button>
      ) : isAdmin ? (
        // Admin context menu for slots
        contextMenu.hasAvailability ? (
          // Show options for available slots (not for past slots)
          <>
            {!contextMenu.isPastSlot && (
              <>
                <button
                  onClick={() => {
                    onToggleHoldStatus();
                    onClose();
                  }}
                  className="w-full px-6 py-2 text-left hover:bg-yellow-50 transition-colors text-yellow-600"
                >
                  <span className="font-medium">
                    {selectedAvailability?.is_on_hold ? 'Release Slot' : 'Hold Slot'}
                  </span>
                </button>
                <button
                  onClick={() => {
                    onDeleteAvailability();
                    onClose();
                  }}
                  className="w-full px-6 py-2 text-left hover:bg-red-50 transition-colors text-red-600"
                >
                  <span className="font-medium">Delete Availability</span>
                </button>
              </>
            )}
          </>
        ) : (
          // Show create options for unavailable slots
          <>
            {/* Only show Appointment option if slot is bookable */}
            {contextMenu.isBookable !== false && (
              <button
                onClick={() => {
                  onAppointmentClick();
                  onClose();
                }}
                className="w-full px-6 py-2 text-left hover:bg-yellow-50 transition-colors"
              >
                <span className="font-medium">Appointment</span>
              </button>
            )}
            {/* Only show Set Availability option if slot is not in the past */}
            {!contextMenu.isPastSlot && (
              <button
                onClick={() => {
                  onAvailabilityClick();
                  onClose();
                }}
                className="w-full px-6 py-2 text-left hover:bg-blue-50 transition-colors"
              >
                <span className="font-medium">Set Availability</span>
              </button>
            )}
          </>
        )
      ) : null}
    </div>
  );
};

export default CalendarContextMenu;
